export const normalizeYear = (
  year: string | number | undefined | null,
  context: string,
) => {
  if (!year && year !== 0) {
    throw new Error(`${context} year is required`);
  }
  const trimmedYear = String(year).trim();
  if (!/^\d{4}$/.test(trimmedYear)) {
    throw new Error(`Invalid ${context} year "${year}". Expected 4 digits.`);
  }
  return trimmedYear;
};
